var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarAM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94.87 94.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007fc0;}.cls-2{fill:#f2e6d3;}.cls-3{fill:#e5d1ba;}.cls-4{fill:#dbbfa1;}.cls-5{fill:#664d42;}.cls-6{fill:#876857;}.cls-7{fill:#75594b;}.cls-8{fill:#37a18e;}.cls-9{fill:#61bfaf;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.43,
    cy: 47.43,
    r: 47.43
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "34.94 63.35 27.51 52.15 27.51 29.12 27.51 15.02 30.73 12.3 46.09 8.64 61.53 12.3 64.67 15.83 64.62 52.19 57.24 63.35 34.94 63.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "64.67 15.83 62.92 13.87 56.36 17.01 60.83 29.89 46.07 33.59 46.07 48.46 60.83 52.14 46.07 63.35 57.24 63.35 60.83 52.14 60.83 29.89 64.65 33.63 64.67 15.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "64.67 18.74 60.83 29.89 60.83 52.14 57.24 63.35 64.67 52.13 64.65 33.61 64.67 18.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "67.41 19.98 67.36 14.49 64.83 14.48 64.85 10.48 60.27 6.82 57.9 8.8 53.07 8.8 53.07 6.84 49.31 6.84 46.09 8.64 42.7 6.84 36.56 6.84 32.83 9.59 26.16 9.59 26.11 14.28 23.59 17.95 26.12 21.98 24.03 24.52 24.03 28 27.53 36.08 31.49 36.08 31.49 30.51 31.49 20.79 35.69 22.65 40.28 20.79 44.41 22.32 49.21 22.34 53.92 21.44 57.24 23.25 60.83 21.53 54.32 16.04 60.83 21.52 60.83 21.53 60.83 25.25 60.83 36.08 64.66 36.08 67.4 27.97 67.4 24.47 64.94 21.99 67.41 19.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "31.49 36.08 27.53 36.08 24.03 28 24.03 24.52 26.14 21.96 31.49 30.51 31.49 36.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "46.09 8.64 42.7 6.84 36.56 6.84 32.83 9.59 26.16 9.59 26.11 14.28 23.59 17.95 40.09 17.99 46.09 8.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "49.31 6.84 46.09 8.64 54.32 16.04 64.83 14.48 64.85 10.48 60.27 6.82 57.9 8.8 53.07 8.8 53.07 6.84 49.31 6.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "23.59 17.95 40.09 17.99 44.41 22.32 40.28 20.79 35.69 22.65 31.49 20.79 31.49 30.51 23.59 17.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "54.32 16.04 46.09 8.64 44.41 22.32 54.32 16.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "64.83 14.48 67.36 14.49 67.41 19.98 64.94 21.99 60.83 25.25 60.83 21.52 54.32 16.04 64.83 14.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.26,91.65a46.91,46.91,0,0,0,15.81,3.17v-21L42.6,66.91,25,71.89l2.22,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.43,94.86A47.29,47.29,0,0,0,66,91.05l.89-19.15L49.7,67l-3.63,6.78v21C46.52,94.84,47,94.86,47.43,94.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.09,92l-.68-19L25,71.9l1.2,17.93A45.42,45.42,0,0,0,31.09,92Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "49.74 73.11 46.07 75.67 42.47 73.11 42.47 63.33 49.74 63.33 49.74 73.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "49.74 71.15 42.47 64.52 49.74 64.52 49.74 71.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 42.47,
    y: 63.33,
    width: 7.27,
    height: 1.18
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "30.47 82.57 25.4 82.57 24.76 71.76 31.26 70.08 30.47 82.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.43,94.86a47.59,47.59,0,0,0,14.65-2.31l1.51-9.41,3.09-1.23.49-10.17L51.43,67.51l-1.71,3.64-3.65.73V94.82C46.52,94.84,47,94.86,47.43,94.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M29.56,91.36a47,47,0,0,0,16.51,3.46V71.88l-3-.73-2.6-3.64L24.78,71.75l2.42,6.36Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAM);
export default __webpack_public_path__ + "static/media/avatar-a-m.9dd27a4da8a73aa5d1b10412c9db54e2.svg";
export { ForwardRef as ReactComponent };